import React, { Component } from 'react';
// import TextField from '@material-ui/core/TextField';
import TextField from '@mui/material/TextField';
import '../style/App.css';

//required Props receive and/or pass back to parent:
// - this.props.handleCompany(value) to pass up values to state (for sending to backend, passed up)
// - this.props.company (content of TextField, pass up and down)

class ContactCompany extends Component {
  constructor(props) {
    super(props)
    this.state = {
      company: ''
    }
    this.handleCompany = this.handleCompany.bind(this);
  }

  handleCompany(value) {
    this.props.handleCompany(value);
  }

  componentDidMount() {
    if (this.props.company) {
      console.log('company: ', this.props.company)
      this.setState({
        company: this.props.company
      })
    }
  }

  render() {
    return (
      <div className='contactFormFieldHolder'>
        <TextField
          onChange={(e) => this.handleCompany(e.target.value)}
          variant="outlined"
          id="company-form"
          label="company"
          value={this.props.company}
          sx={{
            width: '100%',
            '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
              borderColor: 'rgb(125, 120, 120)'
            },
            '& .MuiInputLabel-root': {
              color: 'rgb(125, 120, 120)'
            }
          }}
        />
      </div>
    )
  }

}

export default ContactCompany;
